    <div class="mb-6 bg-white border border-gray-200 rounded-2xl p-4 shadow-sm">

        <div class="flex flex-col lg:flex-row lg:items-center gap-4">

            <!-- Search Input -->
            <div class="relative flex-1">
                <input
                    type="text"
                    placeholder="Search properties by name, location, or builder..."
                    [(ngModel)]="searchTerm"
                    (input)="onSearchChange()"
                    class="w-full h-12 pl-12 pr-4 bg-gray-50 border border-gray-200 rounded-xl text-sm font-medium 
                        focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition-all" />

                <svg class="absolute left-4 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-400"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                </svg>
            </div>

            <!-- Buttons Group -->
            <div class="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">

                <!-- Search Button -->
                <button
                    type="button"
                    (click)="searchItem()"
                    class="h-12 px-6 rounded-xl border border-gray-200 bg-gray-50 text-gray-700 font-semibold
                        hover:bg-gray-100 transition-all duration-200 flex items-center justify-center gap-2">

                    <svg class="h-5 w-5"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
                    </svg>

                    Search
                </button>

                <!-- Make Slider Button -->
                <button
                    type="button"
                    (click)="createDashToken()"
                    class="h-12 px-6 rounded-xl bg-indigo-600 text-white font-semibold shadow-md
                        hover:bg-indigo-700 hover:shadow-lg transition-all duration-200
                        flex items-center justify-center gap-2">

                    <span>Make Slider</span>

                    <span class="px-2 py-0.5 text-xs rounded-full bg-white/20">
                        {{ selectedPropertyIds.size }}/5
                    </span>
                </button>

            </div>

        </div>

    </div>
    <!-- Selected Properties Chips -->
    <div *ngIf="selectedData.length > 0" 
        class="mb-5 p-4 bg-indigo-50 border border-indigo-100 rounded-2xl">

        <div class="flex justify-between items-center mb-3">
            <h3 class="text-sm font-bold text-indigo-900">
                Selected Properties ({{ selectedPropertyIds.size }}/{{ maxSelection }})
            </h3>

            <div class="flex items-center gap-4">
                <button
                    type="button"
                    (click)="downloadCiTemplate()"
                    [disabled]="ciTemplateLoading"
                    title="Excel CI template filled with the selected properties"
                    class="flex items-center gap-1.5 text-xs text-indigo-700 font-semibold hover:underline disabled:opacity-50">
                    <i class="fas" [ngClass]="ciTemplateLoading ? 'fa-circle-notch fa-spin' : 'fa-file-excel'"></i>
                    Download CI Template
                </button>
                <button 
                    (click)="selectedPropertyIds.clear()"
                    class="text-xs text-red-500 font-semibold hover:underline">
                    Clear All
                </button>
            </div>
        </div>

        <div class="flex flex-wrap gap-2">
            <div *ngFor="let property of selectedData"
                class="sticky top-4 z-20 flex items-center gap-2 px-3 py-2 bg-white border border-indigo-200 rounded-full shadow-sm">

                <span class="text-sm font-medium text-gray-700">
                    {{ property.name }}
                </span>

                <button 
                    (click)="togglePropertySelection(property._id)"
                    class="text-red-500 cursor-pointer hover:text-red-700">
                    ✕
                </button>

            </div>
        </div>

        <p class="text-xs text-gray-500 mt-3">
            Select up to {{ maxSelection }} properties to download the CI template. Make Slider needs exactly {{ sliderLimit }}.
        </p>
    </div>


    <div *ngIf="filteredProperties.length > 0" class="grid grid-cols-1 gap-6 sm:hidden">
        <div *ngFor="let property of filteredProperties; let i = index" class="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden transition-all duration-300 transform hover:shadow-xl animate-fade-in" [style.animationDelay.ms]="i * 50">

            <div class="h-40 bg-gray-100 relative">
                <span [ngClass]="{ 
                'bg-red-600': property.isSoldOut, 
                'bg-green-600': !property.isSoldOut 
            }" class="absolute top-3 left-3 text-xs font-bold text-white px-3 py-1 rounded-full shadow-md">
                    {{ property.isSoldOut ? 'SOLD OUT' : 'AVAILABLE' }}
                </span>
                <span *ngIf="property.isLiked" class="absolute top-3 right-3 text-yellow-500">
                    <svg class="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path d="M10 15l-5.878 3.09 1.123-6.545L.487 7.244l6.572-.955L10 1l2.941 5.289 6.572.955-4.758 4.301 1.123 6.545z" />
                    </svg>
                </span>
                <div class="flex items-center justify-center h-full text-gray-400 text-base">
                    <img [src]="property?.galleryImage" alt="property image">
                </div>
            </div>

            <div class="p-4">
                <div class="flex justify-between items-start mb-3">
                    <h3 class="text-lg font-extrabold text-gray-900 leading-snug">
                        {{ property.name || 'Untitled Property' }}
                    </h3>
                    <p class="text-xl font-extrabold text-indigo-600">
                        {{ formatPriceDisplay(property.price) }}
                    </p>
                </div>

                <div class="flex justify-between text-xs font-medium text-gray-600 border-t border-b border-gray-100 py-2 mb-3">
                    <span class="flex items-center text-nowrap">🛌 {{ getBHKAndPriceRange(property.price).bhkRange}}</span>
                    <span class="flex items-center">📐 {{ property.landArea }} Sq Ft</span>
                    <span class="flex items-center">🏠 {{ property.propertyType }}</span>
                </div>

                <div class="flex items-center text-sm text-gray-500 mb-4">
                    <svg class="w-4 h-4 mr-1.5 text-red-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <span class="truncate">{{ property.location || 'Location not specified' }}</span>
                </div>

                <div class="flex items-center justify-between mb-4">
                    <span class="text-xs font-medium text-gray-500">CI Generation</span>
                    <span [ngClass]="ciGenerationStatus(property) === 'Generated' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'"
                                      class="px-3 py-1 text-[10px] font-bold rounded-full whitespace-nowrap">
                                    {{ ciGenerationStatus(property) }}
                                </span>
                </div>

                <button (click)="viewDetails(property)" class="w-full py-2 text-sm font-semibold rounded-lg text-white bg-indigo-600 hover:bg-indigo-700 transition-colors duration-200 shadow-md">
                    View Details
                </button>
            </div>
        </div>
    </div>
    <div class="hidden sm:block border-1 border-gray-200 overflow-hidden rounded-2xl bg-white animate-fade-in-slow">
        <div class="overflow-x-auto rounded-xl border border-gray-200 shadow-sm bg-white">
            <table class="min-w-full divide-y divide-gray-200 hidden md:table">
                <thead class="bg-indigo-50">
                    <tr class="text-[10px] lg:text-xs font-bold tracking-wider text-gray-500 uppercase">
                        <th scope="col" class="px-4 lg:px-6 py-4 text-left">
                            <input 
                                type="checkbox" 
                                [checked]="isAllSelected()"
                                (change)="toggleSelectAll($event)"
                                class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer" />
                        </th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-left">Property / Builder</th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-left">Type</th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-center">Beds</th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-right">Price</th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-center">Status</th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-center whitespace-nowrap">CI Generation</th>
                        <th scope="col" class="px-4 lg:px-6 py-4 text-center">Actions</th>
                    </tr>
                </thead>
            
                <tbody class="bg-white divide-y divide-gray-200">
                    <ng-container *ngIf="filteredProperties.length > 0; else noPropertiesFound">
                        <!-- (filteredProperties | propertySearch: searchTerm) | slice:0:10; -->
                        <tr *ngFor="let property of filteredProperties;let i = index" 
                            class="hover:bg-indigo-50/50 transition-colors duration-300 group"
                            [class.bg-indigo-50]="isPropertySelected(property._id)">
                            
                            <td class="px-4 lg:px-6 py-4">
                                <input 
                                    type="checkbox" 
                                    [checked]="isPropertySelected(property._id)"
                                    (change)="togglePropertySelection(property._id)"
                                    class="h-4 w-4 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500 cursor-pointer" />
                            </td>
                            
                            <td class="px-4 lg:px-6 py-4">
                                <div class="flex flex-col">
                                    <p class="text-base font-bold text-gray-900 group-hover:text-indigo-600 transition-colors">{{ property.name }}</p>
                                    <p class="text-xs text-gray-500 flex items-center mt-1">
                                        <i class="fas fa-map-marker-alt mr-1 text-rose-500"></i> {{ property.location || 'N/A' }}
                                    </p>
                                </div>
                            </td>
            
                            <td class="px-4 lg:px-6 py-4 text-sm font-semibold text-gray-700">
                                {{ property.propertyType }}
                            </td>
            
                            <td class="px-4 lg:px-6 py-4 text-center text-base font-bold text-indigo-600 text-nowrap">
                                {{getBHKAndPriceRange(property.price).bhkRange}}
                            </td>
            
                            <td class="px-4 lg:px-6 py-4 text-right">
                                <p class="text-base font-black text-emerald-700">{{ formatPriceDisplay(property.price) }}</p>
                            </td>
            
                            <td class="px-4 lg:px-6 py-4 text-center">
                                <span [ngClass]="property.isSoldOut ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'" 
                                      class="px-3 py-1 text-[10px] font-bold rounded-full uppercase tracking-tighter">
                                    {{ property.isSoldOut ? 'Sold Out' : 'Active' }}
                                </span>
                            </td>
            
                            <td class="px-4 lg:px-6 py-4 text-center">
                                <span [ngClass]="ciGenerationStatus(property) === 'Generated' ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-600'"
                                      class="px-3 py-1 text-[10px] font-bold rounded-full whitespace-nowrap">
                                    {{ ciGenerationStatus(property) }}
                                </span>
                            </td>

                            <td class="px-4 lg:px-6 py-4">
                                <div class="flex items-center justify-center space-x-2">
                                    <button (click)="navigateToGallery(property)" class="p-2 text-indigo-600 hover:bg-indigo-600 hover:text-white rounded-lg transition-all" title="Upload">
                                        <i class="fas fa-upload text-sm"></i>
                                    </button>
                                    <button (click)="viewDetails(property)" class="px-4 py-2 bg-indigo-50 text-indigo-700 text-xs font-bold rounded-lg hover:bg-indigo-600 hover:text-white transition-all">
                                        Details
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
            
                    <ng-template #noPropertiesFound>
                        <tr>
                            <td colspan="8" class="px-6 py-20 text-center">
                                <div class="flex flex-col items-center justify-center">
                                    <div class="bg-gray-50 p-4 rounded-full mb-4">
                                        <i class="fas fa-search-location text-4xl text-gray-300"></i>
                                    </div>
                                    <h3 class="text-lg font-bold text-gray-900">No properties found</h3>
                                    <p class="text-sm text-gray-500 max-w-xs mx-auto">
                                        We couldn't find any properties matching your current search or filter criteria.
                                    </p>
                                    <button (click)="resetFilters()" class="mt-4 text-indigo-600 font-bold text-sm hover:underline">
                                        Clear all filters
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </tbody>
            </table>
            <!-- Pagination -->
<div class="flex flex-col sm:flex-row items-center justify-between px-4 py-3 bg-white border-t border-gray-200 gap-3">
  
    <!-- Info -->
    <p class="text-sm text-gray-500">
      Showing 
      <span class="font-bold text-gray-800">{{getStartIndex(meta)}}</span>
      –
      <span class="font-bold text-gray-800">{{ getEndIndex(meta) }}</span>
      of
      <span class="font-bold text-gray-800">{{ meta.total }}</span>
      properties
    </p>
  
    <!-- Pages -->
    <div class="flex items-center gap-1">
  
      <!-- Previous -->
      <button 
        (click)="onPageChange(meta.page - 1)"
        [disabled]="meta.page === 1"
        class="px-3 py-2 text-sm font-medium rounded-lg transition-all"
        [ngClass]="meta.page === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-indigo-600 hover:bg-indigo-50'">
        <i class="fas fa-chevron-left"></i>
      </button>
  
      <!-- Page Numbers -->
      <ng-container *ngFor="let page of getPageNumbers()">
        <!-- Dots -->
        <span *ngIf="page === -1" class="px-2 py-2 text-gray-400 text-sm">...</span>
  
        <!-- Page Button -->
        <button 
          *ngIf="page !== -1"
          (click)="onPageChange(page)"
          [ngClass]="page === meta.page 
            ? 'bg-indigo-600 text-white shadow' 
            : 'text-gray-600 hover:bg-indigo-50'"
          class="w-9 h-9 text-sm font-bold rounded-lg transition-all">
          {{ page }}
        </button>
      </ng-container>
  
      <!-- Next -->
      <button 
        (click)="onPageChange(meta.page + 1)"
        [disabled]="meta.page === meta.totalPages"
        class="px-3 py-2 text-sm font-medium rounded-lg transition-all"
        [ngClass]="meta.page === meta.totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-indigo-600 hover:bg-indigo-50'">
        <i class="fas fa-chevron-right"></i>
      </button>
  
    </div>
  
    <!-- Per page -->
    <div class="flex items-center gap-2 text-sm text-gray-500">
      <span>Rows per page:</span>
      <select 
        (change)="onLimitChange($event)"
        class="border border-gray-200 rounded-lg px-2 py-1 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500">
        <option *ngFor="let opt of [20, 50, 150]" [value]="opt" [selected]="opt === meta.limit">{{ opt }}</option>
      </select>
    </div>
  
  </div>

            <div class="md:hidden">
                <div *ngFor="let property of filteredProperties" class="p-4 border-b border-gray-100 last:border-0">
                    <div class="flex justify-between items-start mb-3">
                        <div class="flex gap-3">
                            <input type="checkbox" class="mt-1 h-5 w-5 text-indigo-600 border-gray-300 rounded" />
                            <div>
                                <h3 class="font-bold text-gray-900 text-lg leading-tight">{{ property.name }}</h3>
                                <p class="text-xs text-gray-500"><i class="fas fa-map-marker-alt text-rose-500"></i> {{ property.location }}</p>
                            </div>
                        </div>
                        <span [ngClass]="property.isSoldOut ? 'bg-red-100 text-red-700' : 'bg-green-100 text-green-700'" class="px-2 py-1 text-[10px] font-bold rounded-md">
                            {{ property.isSoldOut ? 'SOLD' : 'ACTIVE' }}
                        </span>
                    </div>

                    <div class="grid grid-cols-2 gap-4 bg-gray-50 p-3 rounded-xl mb-4">
                        <div>
                            <p class="text-[10px] uppercase font-bold text-gray-400">Type</p>
                            <p class="text-sm font-semibold text-gray-800">{{ property.propertyType }}</p>
                        </div>
                        <div>
                            <p class="text-[10px] uppercase font-bold text-gray-400 text-nowrap">Beds</p>
                            {{getBHKAndPriceRange(property.price).bhkRange}}
                        </div>
                        <div class="col-span-2">
                            <p class="text-[10px] uppercase font-bold text-gray-400">Price</p>
                            <p class="text-lg font-black text-emerald-700">{{ formatPriceDisplay(property.price)}}</p>
                        </div>
                    </div>

                    <div class="flex gap-2">
                        <button (click)="viewDetails(property)" class="flex-1 py-3 bg-indigo-600 text-white font-bold rounded-xl text-sm active:scale-95 transition-all">
                            View Details
                        </button>
                        <button (click)="navigateToGallery(property)" class="w-12 h-12 flex items-center justify-center border-2 border-dashed border-indigo-200 text-indigo-600 rounded-xl">
                            <i class="fas fa-camera"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #noPropertiesFound>
            <div class="text-center w-full p-12 bg-white rounded-xl border-2 border-dashed border-gray-300 shadow-lg">
                <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2m-7 7h-2"></path>
                </svg>
                <h3 class="mt-2 text-sm font-medium text-gray-900">No Properties Found</h3>
                <p class="mt-1 text-sm text-gray-500">
                    Adjust your search or clear your filters.
                </p>
            </div>
        </ng-template>
    </div>

    <div *ngIf="isGenerateLink()" class="fixed inset-0 z-[200] flex items-center justify-center bg-gray-900/60 backdrop-blur-md p-4">
        <div class="bg-white w-full max-w-md rounded-[2.5rem] shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-300">
          
          <div class="p-8 pb-4 flex justify-between items-start">
            <div>
              <h2 class="text-2xl font-black text-gray-900 leading-tight">Share Properties</h2>
              <p class="text-sm font-bold text-indigo-600 uppercase tracking-widest mt-1">
                {{ selectedPropertyIds.size }} / 5 Selected
              </p>
            </div>
            <button (click)="closeSharePropertyModal()" class="p-2 bg-gray-50 rounded-full text-gray-400 hover:text-red-500 transition-colors">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>
          </div>
      
          <div class="px-8 pb-8">
            
            <div *ngIf="selectedPropertyIds.size > 5" class="bg-rose-50 border-2 border-rose-100 rounded-3xl p-6 text-center animate-in shake duration-500">
              <div class="w-16 h-16 bg-rose-100 text-rose-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i class="fas fa-exclamation-triangle text-2xl"></i>
              </div>
              <h3 class="text-rose-900 font-bold text-lg">Limit Exceeded</h3>
              <p class="text-rose-700 text-sm mt-2">
                You can only share up to **5 properties** at a time. Please remove {{ selectedPropertyIds.size - 5 }} property to continue.
              </p>
            </div>
      
            <div *ngIf="isSelectionValid">
              <p class="text-gray-500 text-sm mb-4">The following properties will be included in your link:</p>
            
              <div class="space-y-3 mb-6">
                <div *ngFor="let item of selectedData" class="flex items-center gap-4 bg-gray-50 p-3 rounded-2xl border border-gray-100">
                  <img [src]="item.galleryImage[0]" class="w-12 h-12 rounded-xl object-cover shadow-sm">
                  <div class="flex-1 overflow-hidden">
                    <h4 class="font-bold text-gray-900 truncate">{{ item.name }}</h4>
                    <p class="text-[10px] text-gray-500 font-bold uppercase">{{ item.propertyType }} • {{ item.location }}</p>
                  </div>
                </div>
              </div>
      
              <div *ngIf="generatedLink" class="bg-indigo-50 border border-indigo-100 rounded-2xl p-4 mb-6">
                <label class="text-[10px] font-black text-indigo-400 uppercase tracking-widest mb-2 block">Shared Link</label>
                <div class="flex items-center gap-2">
                  <input type="text" readonly [value]="generatedLink" class="bg-transparent border-none text-indigo-700 font-bold text-sm w-full focus:ring-0">
                  <button  class="bg-white text-indigo-600 px-4 py-2 rounded-xl text-xs font-black shadow-sm hover:bg-indigo-600 hover:text-white transition-all">
                    {{ isCopied ? 'COPIED!' : 'COPY' }}
                  </button>
                </div>
              </div>
      
              <button 
                *ngIf="!generatedLink"
                (click)="generateShareLink()"
                [disabled]="isLoading"
                class="w-full py-4 bg-gray-900 text-white rounded-2xl font-bold shadow-xl hover:bg-indigo-600 transition-all disabled:opacity-50">
                <span *ngIf="!isLoading">Create Carousel</span>
                <i *ngIf="isLoading" class="fas fa-circle-notch fa-spin"></i>
              </button>
            </div>
      
            <div *ngIf="selectedPropertyIds.size === 0" class="text-center py-10 text-gray-400">
              <i class="far fa-check-square text-4xl mb-4 block opacity-20"></i>
              <p class="font-bold">Select at least one property to share</p>
            </div>
      
          </div>
        </div>
      </div>